import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import showUserMessage from '../../../utils/showUserMessage.ts';

type ShortcutIconSetProps = {
  iconContent: string;
  color?: string;
  fill?: string;
};

const parseSvgString = (svgString: string): React.ReactNode[] => {
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');

  const errorNode = svgDoc.querySelector('parsererror');
  if (errorNode) {
    console.error(`Error parsing SVG: ${errorNode.textContent}`);
    showUserMessage(
      'Seems like there is an issue with the shortcut icon. Please clear your shortcuts and pin again',
      'warning',
    );
    return [];
  }

  const svgElement = svgDoc.documentElement;

  return Array.from(svgElement.childNodes)
    .filter(node => node.nodeType === Node.ELEMENT_NODE)
    .map((node, index) => {
      const element = node as Element;
      const tagName = element.tagName;
      const nodeAttributes = element.attributes;
      const attributes = Array.from(nodeAttributes).reduce(
        (acc, attr) => {
          acc[attr.name] = attr.value;
          return acc;
        },
        {} as { [key: string]: unknown },
      );
      return React.createElement(tagName, { key: index, ...attributes });
    });
};

const ShortcutIconSvg = (props: ShortcutIconSetProps) => {
  const { iconContent, color = '#fff', fill = '#fff' } = props;

  return <SvgIcon style={{ fill, color, stroke: 'none' }}>{parseSvgString(iconContent)}</SvgIcon>;
};

export default ShortcutIconSvg;
